import React, { useEffect, useState } from 'react';
import { PrimaryButton, SecondaryButton } from 'library';
import useSignUpAction from 'parent-portal/login/SignUpAction';
import { useHistory } from 'react-router';
import { Grid } from '@mui/material';
import useTrackingCookies from 'parent-portal/shared/EngagementSourceTracking';
import usePublicSessionTracking from 'parent-portal/shared/PublicSessionTracking';
import { useCookies } from 'react-cookie';
import LearnMoreModal from '../on-demand/LearnMore/LearnMoreModal';
import EldercareInfoSection from './EldercareInfoSection';
import EldercareWhyTandem from './EldercareWhyTandem';
import EldercareSolution from './EldercareSolution';
import EldercareHowItWorks from './EldercareHowItWorks';

export default function EldercareLandingPage() {
    useTrackingCookies('/facilities');
    const { usePageLoadTracking } = usePublicSessionTracking('Eldercare Landing Page');
    const [cookies, setCookie] = useCookies();
    const [openLearnMore, setOpenLearnMore] = useState(false);

    usePageLoadTracking();

    useEffect(() => {
        setCookie('isBusiness', true);
    }, []);

    const history = useHistory();
    const { SignUpWrapper, signUp } = useSignUpAction(undefined);

    function ButtonGroup() {
        return (
            <Grid style={{ gap: 10, height: 75 }} item container flexDirection="row">
                <SecondaryButton onClick={() => setOpenLearnMore(true)} buttonStyle={{ width: 200, marginTop: 20 }}>
                    Learn More
                </SecondaryButton>
                <PrimaryButton onClick={signUp} buttonStyle={{ width: 200, marginTop: 20 }}>
                    Get Started
                </PrimaryButton>
            </Grid>
        );
    }

    return (
        <SignUpWrapper businessSignup={true} businessType="ELDERCARE">
            <Grid container item>
                <EldercareInfoSection ButtonGroup={ButtonGroup} />
                <EldercareWhyTandem />
                <EldercareSolution />
                <EldercareHowItWorks ButtonGroup={ButtonGroup} />
                <LearnMoreModal open={openLearnMore} onClose={() => setOpenLearnMore(false)} />
            </Grid>
        </SignUpWrapper>
    );
}
